import { useTranslation } from "react-i18next";

export default function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const cur = i18n.language?.startsWith("en") ? "en" : "es";
  return (
    <div className={`flex gap-1 ${className}`} data-testid="language-toggle">
      {["es", "en"].map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => i18n.changeLanguage(lng)}
          className={`px-2 py-0.5 rounded-full text-[11px] font-bold border transition-colors duration-200 ${
            cur === lng
              ? "bg-primary text-primary-foreground border-primary"
              : "text-muted-foreground border-border hover:text-foreground"
          }`}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
